// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconModalClose: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
        >
            <defs>
                <path
                    id="a"
                    d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z"
                />
            </defs>
            <g fill="none">
                <use xlinkHref="#a" fill="currentColor" fillRule="evenodd" />
                <path
                    fill="#FFF"
                    d="M16.7541272,15.7231063 C17.0469384,16.0151259 17.0469384,16.4889226 16.7541272,16.7809735 C16.461316,17.0730245 15.986235,17.0729931 15.6933923,16.7809735 L12.00051,13.0706461 L8.28137511,16.7797265 C7.98856345,17.0717461 7.51348291,17.0717461 7.22064025,16.7797265 C6.92779759,16.4877069 6.92782859,16.0139103 7.22064025,15.7218593 L10.9410251,12.0140258 L7.21960874,8.27689369 C6.92679709,7.9848741 6.92679709,7.51107743 7.21960874,7.21902646 C7.5124204,6.92697549 7.98750095,6.92700688 8.2803436,7.21902646 L12.00051,10.9574056 L15.719645,7.24832515 C16.0124561,6.95630557 16.4875372,6.95630557 16.7803798,7.24832515 C17.0732225,7.54034474 17.073191,8.01414141 16.7803798,8.30619238 L13.0599945,12.0140258 L16.7541272,15.7231063 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconModalClose);
